import React, { Component } from 'react';
import cx from 'classnames';
import _get from 'lodash.get';
import FiltersGroupContainer from './FiltersGroupContainer';
import FiltersGroupLabel from './FiltersGroupItemLabel';
import RadioButton from '../../RadioButtons/components/RadioButton';
import DatePicker from '../../DatePicker';
import Button from '../../Button';
import '../styles/_dateRangeFilters.scss';
































export default class DateRangeFiltersGroup extends Component
{
  static defaultProps = {
    selectedValues: []
  };

  constructor(props) {
    super(props);

    this.state = {
      startDate: _get(props, 'selectedValues.length') > 1 ? props.selectedValues[0] : '',
      endDate: _get(props, 'selectedValues.length') > 1 ? props.selectedValues[1] : '',
      selected: this.getSelectedDefaultValue(props)
    };
  }

  componentDidUpdate(prevProps) {
    const { selectedValues } = this.props;

    if (prevProps.selectedValues.length !== selectedValues.length && selectedValues.length !== 2) {
      this.resetFilter();
    }
  }

  getSelectedDefaultValue = (
  { filterFacets, selectedValues }) =>
  {
    if (selectedValues && selectedValues.length === 2) {
      // $FlowFixMe
      const { value: defaultValue } = filterFacets.find((value) => !value.selectedDefault);

      return defaultValue;
    }

    return this.setDefaultValue(filterFacets);
  };

  handleFilterChange = (
  { selectedDefault, value }) =>
  () => {
    const { onChange } = this.props;

    if (selectedDefault) {
      this.setState({
        startDate: '',
        endDate: '',
        selected: value
      });

      onChange([]);
      return void 0;
    }
    this.setState({
      selected: value
    });
  };

  setDate = (type) => (date) => {
    this.setState({ [type]: date ? date.toISOString() : '' });
  };

  handleDateRangeChanges = () => {
    const { startDate, endDate } = this.state;
    const { onChange } = this.props;

    onChange([startDate, endDate]);
  };

  filterIsSelected = ({
    selectedDefault,
    selectedValues,
    value
  }) =>
  {
    const { selected } = this.state;

    // TODO This logic needs to be reworked for better compatibility for >2 options and for readability
    if (selectedDefault) {return selectedValues.length !== 2 && selected === value;}

    return selectedValues.length === 2 || selected === value;
  };

  resetFilter = () => {
    const { filterFacets = [] } = this.props;

    this.setState({
      selected: this.setDefaultValue(filterFacets),
      startDate: '',
      endDate: ''
    });
  };

  setDefaultValue = (filterFacets) => {
    const filterWithDefaultValue = filterFacets.find((value) => value.selectedDefault);

    return filterWithDefaultValue ? filterWithDefaultValue.value : '';
  };

  render() {
    const {
      filterFacets,
      label: groupLabel,
      isCollapsible,
      openedByDefault,
      selectedValues,
      minWidth
    } = this.props;
    const { startDate, endDate } = this.state;

    return (
      <FiltersGroupContainer
        label={groupLabel}
        isCollapsible={isCollapsible}
        openedByDefault={openedByDefault}
        minWidth={minWidth}>

        {filterFacets.map(({
          label,
          value,
          selectedDefault,
          disabled,
          id = 'filter',
          startLabel = 'From',
          startPlaceholder = 'Select date',
          endLabel = 'To',
          endPlaceholder = 'Select date',
          showDateRange }) => showDateRange ?

        <>
              <RadioButton
            key={value}
            value={value}
            disabled={disabled}
            // $FlowFixMe
            selected={this.filterIsSelected({ selectedDefault, selectedValues, value })}
            // $FlowFixMe
            onChange={this.handleFilterChange({ value, selectedDefault })}>

                <FiltersGroupLabel label={label} />
              </RadioButton>
              <div className={cx('date-range', {
            // $FlowFixMe
            'date-range--opened': this.filterIsSelected({ selectedDefault, selectedValues, value })
          })}>

                <DatePicker
              startLabel={startLabel}
              endLabel={endLabel}
              startPlaceholder={startPlaceholder}
              endPlaceholder={endPlaceholder}
              onSelectStartDate={this.setDate('startDate')}
              onSelectEndDate={this.setDate('endDate')}
              startDate={startDate}
              endDate={endDate}
              id={id}
              enablePastDays
              openDown />

                <div className="date-range__button">
                  <Button
                type="SECONDARY"
                disabled={!startDate || !endDate}
                onClick={this.handleDateRangeChanges}>

                    Apply Changes
                  </Button>
                </div>
              </div>
            </> :


        <RadioButton
          key={value}
          value={value}
          disabled={disabled}
          // $FlowFixMe
          selected={this.filterIsSelected({ selectedDefault, selectedValues, value })}
          // $FlowFixMe
          onChange={this.handleFilterChange({ value, selectedDefault })}>

              <FiltersGroupLabel label={label} />
            </RadioButton>
        )}

      </FiltersGroupContainer>);

  }
}